//core
import React from 'react';
//utils
import moment from 'moment';
//icons
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronLeft, faChevronRight} from '@fortawesome/free-solid-svg-icons';

interface IProps {
  date: string;
  setDate: React.Dispatch<string>;
}

export default function DateFilter({date, setDate}: IProps) {
  return (
    <div className="d-flex flex-row justify-content-between my-2 mx-1 h2 no-user-select">
      <div className="pr-5 cursor-pointer" onClick={() => setDate(moment(date).add(-1, 'd').format('YYYY-MM-DD'))}>
        <FontAwesomeIcon icon={faChevronLeft} />
      </div>
      <div className="pl-5 cursor-pointer" onClick={() => setDate(moment(date).add(1, 'd').format('YYYY-MM-DD'))}>
        <FontAwesomeIcon icon={faChevronRight} />
      </div>
    </div>
  );
}
